import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import classNames from 'classnames';

import { formatDate } from '../../utils/functions';
import { ElementLink } from '../../components';

export class TopOfferCell extends Component {
  render() {
    const { offer, trRef, fade } = this.props;

    function storeName() {
      return offer.store ? offer.store.name : '';
    }

    return (
      <ElementLink
        element="tr"
        to={`/offers/${offer.id}/edit`}
        className={classNames('offer-cell', { fade })}
        elementRef={trRef}
      >
        <td className="offer-cell-store">{storeName()}</td>
        <td className="offer-cell-title">{offer.title}</td>
        <td className="offer-cell-start-date">{formatDate(offer.startDate)}</td>
        <td className="offer-cell-end-date">{formatDate(offer.endDate)}</td>
      </ElementLink>
    );
  }
}

export default createFragmentContainer(TopOfferCell, {
  offer: graphql`
    fragment TopOfferCell_offer on Offer {
      id
      title
      startDate
      endDate
      store {
        name
      }
    }
  `,
});
